<template>
  <div>
    <!-- 通知公告改名字通知公告 + 搜索框 -->
    <div class="notice">
      <img class="notice-img" src="../assets/img/notice.png" alt="" />
      <span style="width: 80px;margin-left: 5px;">通知公告：</span>
      <el-carousel
        indicator-position="none"
        direction="vertical"
        height="40px"
        style="width: 765px;margin-left: 10px; color: #ff0000;"
      >
        <el-carousel-item
          v-for="item in tzggList"
          @click.native="tonews(73, item.id)"
        >
          {{ item.title }}
        </el-carousel-item>
      </el-carousel>
      <el-input
        id="keyword"
        placeholder="请输入关键词"
        v-model="keyword"
        style="width: 200px;"
      >
        <i
          slot="suffix"
          class="el-input__icon el-icon-search"
          @click="seach"
        ></i>
      </el-input>
    </div>
    <!-- 网上营业大厅 -->
    <div class="wsyydt" v-if="wsyydt">
      <div class="wsyydt-text">
        <a href="https://service.hszfgjj.org.cn/ish/" target="_blank"
          >网上营业大厅>></a
        >
      </div>
      <div class="wsyydt-phone">
        客服电话：0318-12329
      </div>
    </div>
    <!-- 效果2 -->
    <div class="wsyydt1" v-if="wsyydt1">
      <a
        class="dwkh"
        href="https://service.hszfgjj.org.cn/ish/"
        target="_blank"
        title="单位开户"
        rel="noreferrer"
      ></a>
      <a
        class="dwyh"
        href="https://service.hszfgjj.org.cn/ish/"
        target="_blank"
        title="单位用户"
        rel="noreferrer"
      ></a>
      <a
        class="gryh"
        href="https://service.hszfgjj.org.cn/ish/"
        target="_blank"
        title="个人用户"
        rel="noreferrer"
      ></a>
    </div>

    <!-- 效果3 -->
    <div class="wsyydt2" v-if="wsyydt2">
      <a
        class="dwyh"
        href="https://service.hszfgjj.org.cn/mish/"
        target="_blank"
        title="我是单位用户"
        rel="noreferrer"
      ></a>

      <a
        class="gryh"
        href="https://service.hszfgjj.org.cn/mish/"
        target="_blank"
        title="我是个人用户"
        rel="noreferrer"
      ></a>
    </div>
    <!-- banner图及时政要闻展示 -->
    <div class="banner-szyw">
      <div class="banner" v-loading="loading_banner">
        <el-carousel
          height="330px"
          :interval="5000"
          arrow="never"
          style="text-align: center;"
        >
          <el-carousel-item v-for="item in bannerList">
            <img
              :src="item.imgpath"
              alt=""
              style="max-height: 330px;width:755px"
              @click="tonews(83, item.id)"
            />
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="szyw">
        <div>
          <span class="szyw-title">时政要闻</span>
          <span class="szyw-gd" @click="tolist(3)">更多>></span>
        </div>
        <div class="szyw-text" v-loading="loading_szyw">
          <ul>
            <li v-for="item in szywList" @click="tonews(83, item.id)">
              <span>{{ item.title | ellipsis(28) }}</span>
              <span class="szyw-text-date"
                >[{{ item.releaseDate | formatTime("YYYY-MM-DD") }}]</span
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 快捷通道 -->
    <div class="kjtd">
      <div style="background-color: #5587BF;" @click="toquick(1)">
        <img src="../assets/img/hsxj.png" style="width: 28px;height: 27px;" />
        <span>衡水小金</span>
      </div>
      <div
        style="margin-left: 26px;background-color: #48A8F0;"
        @click="toquick(2)"
      >
        <img src="../assets/img/zczx.png" style="width: 28px;height: 27px;" />
        <span>政策咨询</span>
      </div>
      <div
        style="margin-left: 26px;background-color: #698FB8;"
        @click="toquick(3)"
      >
        <img src="../assets/img/tsjy.png" style="width: 28px;height: 27px;" />
        <span>投诉与建议</span>
      </div>
      <div
        style="margin-left: 26px;background-color: #95C05E;"
        @click="toquick(4)"
      >
        <img src="../assets/img/dkss.png" style="width: 28px;height: 27px;" />
        <span>贷款试算</span>
      </div>

      <div
        style="margin-left: 26px;background-color: #57ACC1;"
        @click="toquick(5)"
      >
        <img src="../assets/img/czzn.png" style="width: 28px;height: 27px;" />
        <span>操作指南</span>
      </div>
      <div
        style="margin-left: 26px;background-color: #68CBA5;"
        @click="tolist(1)"
      >
        <img src="../assets/img/zczx.png" style="width: 28px;height: 27px;" />
        <span>表格下载</span>
      </div>
    </div>
    <!-- 通知公告  工作动态  业务指南 -->
    <div class="tzgg-gzdt-ywzn">
      <div class="tzgg">
        <div>
          <span class="tzgg-title">通知公告</span>
          <span class="tzgg-gd" @click="tolist(2)">更多>></span>
        </div>
        <div class="tzgg-text" v-loading="loading_tzgg">
          <ul>
            <li v-for="item in tzggList" @click="tonews(78, item.id)">
              <span>{{ item.title | ellipsis(22) }}</span>
              <span class="szyw-text-date"
                >[{{ item.releaseDate | formatTime("YYYY-MM-DD") }}]</span
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="gzdt">
        <div>
          <span class="gzdt-title">工作动态</span>
          <span class="gzdt-gd" @click="tolist(4)">更多>></span>
        </div>
        <div class="gzdt-text" v-loading="loading_gzdt">
          <ul>
            <li v-for="item in gzdtList" @click="tonews(79, item.id)">
              <span>{{ item.title | ellipsis(22) }}</span>
              <span class="szyw-text-date"
                >[{{ item.releaseDate | formatTime("YYYY-MM-DD") }}]</span
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="ywzn">
        <div class="ywzn-img">
          <img src="../assets/img/ywzn.png" alt="" />
          <span>业务指南</span>
        </div>
        <div class="ywzn-jc" @click="tolist(9)">
          <img src="../assets/img/jc.png" alt="" />
          <span>缴存</span>
        </div>
        <div class="ywzn-zq" @click="tolist(10)">
          <img src="../assets/img/zq.png" alt="" />
          <span>提取</span>
        </div>
        <div class="ywzn-dk" @click="tolist(11)">
          <img src="../assets/img/dk.png" alt="" />
          <span>贷款</span>
        </div>
      </div>
    </div>
    <!-- 网点分布  行政执法公示  预算决算公开栏 -->
    <div class="wdfb-xzzfgs-ysjsgkl">
      <div class="wdfb" @click="tolist(12)">
        <img src="../assets/img/wdfb.png" style="width: 40px;height: 40px;" />
        <span>网点分布</span>
      </div>
      <div class="xzzfgs" @click="tolist(13)">
        <img src="../assets/img/xzzfgs.png" style="width: 40px;height: 40px;" />
        <span>行政执法公示</span>
      </div>
      <div class="sqxzjcgszl" @click="toSqxzjcgszl()">
        <img src="../assets/img/xzzfgs.png" style="width: 40px;height: 40px;" />
        <span>涉企行政检查公示专栏</span>
      </div>
      <div class="ysjsgkl" @click="tolist(14)">
        <img
          src="../assets/img/ysjsgkl.png"
          style="width: 40px;height: 40px;"
        />
        <span>预算决算公开栏</span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import qs from "qs"
export default {
  filters: {
    //限制文本显示字数,超出部分用...代替
    ellipsis(value, index) {
      if (!value) return ""
      if (value.length > index) {
        return value.slice(0, index) + "..." //0:下标,从第一个字开始显示,50:显示字数,多余用...代替
      }
      return value
    },
    formatTime(value, format = "YYYY-MM-DD") {
      if (!value) return ""
      const date = new Date(value)
      const options = {
        "Y+": date.getFullYear().toString(), // 年
        "M+": (date.getMonth() + 1).toString(), // 月
        "D+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "m+": date.getMinutes().toString(), // 分
        "S+": date.getSeconds().toString(), // 秒
        // 可以继续添加其他格式化选项
      }
      for (let k in options) {
        const reg = new RegExp(`(${k})`)
        if (reg.test(format)) {
          format = format.replace(
            reg,
            options[k].length === 1 ? `0${options[k]}` : `${options[k]}`
          )
        }
      }
      return format
    },
  },
  data() {
    return {
      activeIndex: 0,
      // wsyydt:true,
      // wsyydt1:false,
      wsyydt: false,
      wsyydt1: false,
      wsyydt2: true,
      //导航按钮
      menuItems: [
        "首页",
        "表格下载",
        "通知公告",
        "时政要闻",
        "行风建设",
        "党务公开",
        "业务流程",
        "政策法规",
      ],
      // banner图
      bannerList: [],
      loading_banner: true,
      // 通知公告 5521
      tzggList: [],
      loading_tzgg: true,
      // 时政要闻 5204
      szywList: [],
      loading_szyw: true,
      // 工作动态 5535
      gzdtList: [],
      loading_gzdt: true,
      //全站搜索参数
      keyword: "",
    }
  },
  created() {
    // 获取工作动态列表
    this.getNewList("0", "5", "79")
    // 新的通知公告列表
    this.getNewList("0", "5", "78")
    // 新的时政要闻列表
    this.getNewList("0", "7", "83")
    this.getBanner()
  },
  methods: {
    // 获取通知公告最新

    getList(pagenum, pagerows, buzType, classification) {
      axios
        .post(
          "/token/admin/huaxin/index",
          qs.stringify({
            data: {
              buzType: buzType,
              keyword: "",
              classification: classification,
              pagenum: pagenum,
              pagerows: pagerows,
            },
            url: "appapi70001.json",
          })
        )
        .then((response) => {
          switch (buzType) {
            // 通知公告
            case "5521":
              this.loading_tzgg = false
              this.tzggList = response.data.result
              break
            // 工作动态
            case "5535":
              this.loading_gzdt = false
              this.gzdtList = response.data.result
              break
            // 时政要闻
            case "5204":
              this.loading_szyw = false
              this.szywList = response.data.result
              break
          }
        })
        .catch(function(error) {
          // 请求失败处理
          console.log(error)
        })
    },

    getNewList(first, count, channelIds) {
      let data = {}
      data.first = first
      data.count = count
      data.channelIds = channelIds
      axios
        .post("/api/gateway/03180/09/web/110418", qs.stringify(data))
        .then((response) => {
          //   this.loading_tzgg = false
          //   this.tzggList = response.data.body
          switch (channelIds) {
            // 通知公告
            case "78":
              this.loading_tzgg = false
              this.tzggList = response.data.body
              break
            // 工作动态
            case "79":
              this.loading_gzdt = false
              this.gzdtList = response.data.body
              break
            // 时政要闻
            case "83":
              this.loading_szyw = false
              this.szywList = response.data.body
              break
          }
        })
    },
    getBanner() {
      let data = {}
      data.channelIds = "112"
      data.first = "0"
      data.count = "4"
      axios
        .post("/api/gateway/03180/09/web/110418", qs.stringify(data))
        .then((response) => {
          this.loading_banner = false
          console.log("res", response.data)
          this.bannerList = response.data.body
          for (let l = 0; l < response.data.body.length; l++) {
            response.data.body[l].picArr[0].picPaths = response.data.body[
              l
            ].picArr[0].picPaths.replace("http://10.20.13.10:32002", "/api")
            this.bannerList[l].imgpath =
              response.data.body[l].picArr[0].picPaths
            // const url = new URL(response.data.body[l].picArr[0].picPaths)
            // const urlParams = new URLSearchParams(url.search)
            // if (urlParams.get("channelId")) {
            //   this.bannerList[l].channelId = urlParams.get("channelId")
            // } else {
            //   this.bannerList[l].channelId = urlParams.get("channelId")
            // }
            // this.bannerList[l].id = urlParams.get("id")
          }
          console.log("bannerList", this.bannerList)
        })
        .catch(function(error) {
          // 请求失败处理
          console.log(error)
        })
    },
    tonews(channelIds, id) {
      this.$router.push({
        path: "/new_details",
        query: { channelIds: channelIds, id: id },
      })
    },
    tolist(index) {
      this.$router.push({ path: "/list?activeIndex=" + index })
    },
    toquick(index) {
      this.$router.push({ path: "/quick?activeIndex=" + index })
    },
    toSqxzjcgszl() {
      this.$router.push({ path: "/sqxzjcgszl?activeIndex=1" })
    },
    seach() {
      this.$router.push({ path: "/qzss?keyword=" + this.keyword })
    },
  },
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

.notice {
  width: 1200px;
  height: 40px;
  background-color: #fff;
  /* margin: 5px auto; */
  line-height: 40px;
  display: flex;
  align-items: center;
}

.notice-img {
  width: 18px;
  height: 18px;
  padding-left: 22px;
}

/deep/ .el-input__inner {
  height: 30px;
}
.el-carousel__item:hover {
  cursor: pointer;
}
.el-input__icon:hover {
  cursor: pointer;
}
/* 轮播图 时政要闻 */
.banner-szyw {
  width: 1200px;
  height: 330px;
  margin: 10px auto;
  display: flex;
  align-items: center;
  border-top: 2px solid #48a8f0;
}

.banner {
  width: 755px;
}

.szyw {
  width: 445px;
  height: 330px;
  background-color: #fff;
}

.szyw-title {
  line-height: 32px;
  margin-left: 14px;
  font-size: 16px;
  color: #0291ef;
}
.szyw-gd {
  line-height: 32px;
  font-size: 12px;
  color: #999999;
  padding-right: 10px;
  float: right;
}
.szyw-gd:hover {
  cursor: pointer;
}
.szyw-text {
  min-height: 300px;
}
.szyw-text ul li {
  padding: 6px 10px;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  list-style-type: none;
  border-bottom: 1px dashed #d2d2d2;
}
.szyw-text ul li:hover {
  cursor: pointer;
  color: #0291ef;
}
.szyw-text-date {
  color: #aaaaaa;
  float: right;
}
/* 网上营业大厅 */
.wsyydt {
  width: 1200px;
  height: 581px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-image: url("../assets/img/gjjdt.png");
}
.wsyydt1 {
  width: 1200px;
  height: 375px;
  margin: 0 auto;
  display: flex;
  background-image: url("../assets/img/gjjdt2.png");
}
.wsyydt2 {
  width: 1200px;
  height: 469px;
  margin: 0 auto;
  display: flex;
  /* background-image: url("../assets/img/gjjdt3.png"); */
  background-image: url("../assets/img/gjjdt4.jpg");
  /* 自适应缩放图片大小，保证清晰度不变 */
  background-size: contain;
}
.dwkh {
  width: 128px;
  height: 148px;
  margin-top: 156px;
  margin-left: 288px;
}
.dwyh {
  width: 156px;
  height: 44px;
  margin-top: 235px;
  margin-left: 422px;
}
.gryh {
  width: 156px;
  height: 44px;
  margin-top: 238px;
  margin-left: 116px;
}
.wsyydt-text {
  width: 284px;
  height: 58px;
  margin-left: 100px;
  /* background-color: #3090D8; */
  font-size: 30px;
  font-weight: 700;
  border: 3px solid #fff;
  text-align: center;
  line-height: 58px;
}

.wsyydt-text a {
  color: #fff;
  text-decoration: none;
}
.wsyydt-phone {
  font-size: 25px;
  font-weight: 700;
  color: #fff;
  margin-right: 100px;
}
/* 快捷通道 */
.kjtd {
  width: 1200px;
  height: 65px;
  margin: 0 auto;
  display: flex;
}

.kjtd div {
  color: #fff;
  width: 178px;
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.kjtd div:hover {
  cursor: pointer;
}

.kjtd span {
  margin-left: 10px;
}

/* 通知公告  工作动态  业务指南 */
.tzgg-gzdt-ywzn {
  width: 1200px;
  height: 251px;
  margin: 20px auto;
  display: flex;
}
.tzgg,
.gzdt,
.ywzn {
  width: 390px;
  height: 251px;
  background-color: #fff;
}
.tzgg,
.gzdt {
  border-top: 4px solid #48a8f0;
  border-left: 1px solid #999999;
  border-right: 1px solid #999999;
  border-bottom: 1px solid #999999;
}
.gzdt,
.ywzn {
  margin-left: 15px;
}
.tzgg-title,
.gzdt-title {
  line-height: 32px;
  margin-left: 14px;
  padding-left: 5px;
  font-size: 16px;
  color: #0291ef;
  border-left: 3px solid #48a8f0;
}
.tzgg-gd,
.gzdt-gd {
  line-height: 32px;
  font-size: 12px;
  color: #999999;
  padding-right: 10px;
  float: right;
}
.tzgg-gd:hover,
.gzdt-gd:hover {
  cursor: pointer;
}
.tzgg-text,
.gzdt-text {
  min-height: 198px;
}
.tzgg-text ul li,
.gzdt-text ul li {
  margin: 12px 10px;
  /* width: 100%; */
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  list-style-type: none;
}
.tzgg-text ul li:hover,
.gzdt-text ul li:hover {
  cursor: pointer;
  color: #0291ef;
}
.ywzn {
  /* border: 2px solid #F3F3F3; */
}
.ywzn-img {
  height: 56px;
  text-align: center;
  position: relative;
}
.ywzn-img span {
  position: absolute;
  top: 10px;
  left: 156px;
  font-size: 18px;
  color: #fff;
}
.ywzn-jc,
.ywzn-zq,
.ywzn-dk {
  height: 66px;
  display: flex;
  align-items: center;
}
.ywzn-jc,
.ywzn-zq,
.ywzn-dk {
  height: 66px;
  display: flex;
  align-items: center;
}
.ywzn-jc:hover,
.ywzn-zq:hover,
.ywzn-dk:hover {
  cursor: pointer;
}
.ywzn-jc img,
.ywzn-zq img,
.ywzn-dk img {
  width: 46px;
  height: 40px;
  margin-left: 129px;
}
.ywzn-jc span,
.ywzn-zq span,
.ywzn-dk span {
  margin-left: 20px;
  color: #3090d8;
}
.ywzn-jc,
.ywzn-dk {
  background-color: #f3f3f3;
}

/* 网点分布  行政执法公示  预算决算公开栏 */
.wdfb-xzzfgs-ysjsgkl {
  width: 1200px;
  height: 80px;
  margin: 30px auto;
  display: flex;
}

.wdfb,
.xzzfgs,
.sqxzjcgszl,
.ysjsgkl {
  width: 360px;
  height: 80px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #48a8f0;
}
.wdfb:hover,
.xzzfgs:hover,
.sqxzjcgszl:hover,
.ysjsgkl:hover {
  cursor: pointer;
}

.xzzfgs,
.sqxzjcgszl,
.ysjsgkl {
  margin-left: 45px;
}

.wdfb-xzzfgs-ysjsgkl span {
  margin-left: 20px;
}
</style>
